import { GetBuildingSearchResObj } from '@gateway.Building'
import { yamadumiApi } from '../yamadumi-api'

export class SearchBuildingGateway {
  /**
   * 物件選択部品用の物件情報一覧取得 API
   */
  static getSearchBuildingList = async (branchCd?: string, constructionNm?: string) => {
    const params = {
      branchCd,
      constructionNm
    }
    return await yamadumiApi.get<GetBuildingSearchResObj>(
      '/api/common/search-building',
      params
    )
  }
}
